export enum MetalsHardwareItemType {
    SheetMetal = 'sheet metal',
    PaintPowder = 'paint powder',
    Hardware = 'hardware',
    Pem = 'Pem',
    Coil = 'Coil',
    Misc = 'misc'
}
